const navLinks = [
	{
		link: "/",
		icon: "home",
		text: "Home",
	},
	{
		link: "/about",
		icon: "info",
		text: "About",
	},
	{
		link: "/team",
		icon: "people",
		text: "Team",
	},
	{
		link: "/wall-of-fame",
		icon: "celebration",
		text: "Events",
	},
	{
		link: "/gallery",
		icon: "image",
		text: "Gallery",
	},
];

export default navLinks;
